export const mark = () => ({
  type: 'change-guard/mark',
  meta: { uiAction: false },
});
mark.toString = () => 'change-guard/mark';

export const reset = () => ({
  type: 'change-guard/reset-success',
  meta: { resetModifiedOnSuccess: true },
});
reset.toString = () => 'change-guard/reset';
